import { Choice } from 'components/Input/ChoiceGroup'
import { pick } from 'dot-object'
import { Transaction } from './tracking.interface'
import common from '../../texts/common/partials/common'

export function getLabelForOption(path: string, option: string) {
  const meta = pick(path, { common }) || []

  if (!meta?.options) {
    return undefined
  }

  return meta.options?.find((o: Choice<unknown>) => o.value === option)?.label
}

interface LeadEventData {
  leadId: string
  revenue: number
  purpose: string
  traversalId: string
  personId: string
  affiliate: string
  productId: string
}

export function getSkuText(purpose: string) {
  /**
   * Users can select this on the WS when the amount is <= 50k.
   * Otherwise, they will be redirected to a special LP.
   * However, we don't want to deal with this in Taurine
   * and therefore the label doesn't exist in our select.
   */
  if (purpose === 'REAL_ESTATE_FINANCING') {
    return 'Immobilienfinanzierung'
  }

  return getLabelForOption('common.purpose', purpose)
}

export function createLeadTransaction({
  leadId,
  revenue,
  purpose,
  affiliate,
  personId,
  productId,
  traversalId
}: LeadEventData): Transaction {
  const category = purpose.toLowerCase()

  return {
    event: 'iframeLead',
    traversalId,
    affiliate,
    personId,
    transactionId: leadId,
    transactionTotal: revenue,
    transactionProducts: [
      {
        sku: getSkuText(purpose) || category,
        name: productId,
        category,
        price: revenue,
        quantity: '1'
      }
    ]
  }
}
